export default __webpack_public_path__ + "static/media/deep_dive.38c69828.svg";